import { SelectValueType } from 'ui/selects';
import { isUndefined } from 'utils/tsHelpers';
import { CatalogData } from '../types';
import { isCatalogQueryValue } from '../utils';
import { useTranslation } from '../../../../hooks';

export const useCatalogValueLabel = (value: CatalogData | SelectValueType | null) => {
  const { t } = useTranslation();
  if (!isCatalogQueryValue(value)) return t('catalogInSegmentation.catalogCriteriaPlaceholder');
  const {
    catalogField,
    catalogQuery: { catalogName },
  } = value;
  return isUndefined(catalogField)
    ? t('catalogInSegmentation.triggerWithKey', { catalogName })
    : t('catalogInSegmentation.triggerWithCatalogField', { catalogField, catalogName });
};
